import { apiRequest } from "../Component/Utils/ApiHundler";

const apiURL = process.env.REACT_APP_API_URL;

export async function getInstanceADM(client = "", model = "", token) {
  const apiUrl = `${apiURL}/admin/process/list/full`;
  let bodyData = {};

  // Assurez-vous que client et model ne sont pas undefined ou 'none' avant de les ajouter à bodyData
  if (model && model !== 'none') {
    bodyData.ModelId = model;
  }
  if (client && client !== 'none') {
    bodyData.ClientId = client;
  }

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(bodyData),
  });

  return data.message.list;
}